<template>
    <div class="h2-wrapper">
        <h2 class="hh2-style3" @click="toggleContent">
            <slot></slot>
            <span v-if="hasContent" class="toggle-btn">
                {{ isHidden ? '+' : '-' }}
            </span>
        </h2>
        <div v-if="hasContent" class="content" :class="{ hidden: isHidden }">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        hide: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isHidden: true
        }
    },
    created() {
        this.isHidden = this.hasContent ? true : false;
        if (this.hide !== undefined) {
            this.isHidden = this.hide;
        }
    },
    computed: {
        hasContent() {
            return !!this.$slots.content;
        }
    },
    methods: {
        toggleContent() {
            if (!!this.$slots.content === false) return;
            this.isHidden = !this.isHidden
        }
    }
}
</script>

<style lang="scss" scoped>
// -------------------------------------
// 风格3绿色版：左侧色块 + 渐变标题
// -------------------------------------
.hh2-style3 {
    font-size: 24px;
    font-weight: 700;
    background: linear-gradient(90deg, #1e7e34, #28a745);
    color: #fff;
    padding: 12px 20px 12px 20px;
    position: relative;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.hh2-style3::before {
    content: '';
    width: 8px;
    height: 100%;
    background: #b6ffce;  /* 亮绿色作为装饰条 */
    border-radius: 4px;
}

.hh2-style3 .toggle-btn {
    margin-left: auto;
    font-size: 20px;
    width: 26px;
    height: 26px;
    line-height: 26px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    border: none;
}

// -------------------------------------
// 公共内容区域样式
// -------------------------------------
.content {
    overflow: hidden;
    transition: all 0.3s ease;
    max-height: 2000px;
    opacity: 1;

    &.hidden {
        max-height: 0;
        opacity: 0;
        margin: 0;
    }
}

@media (max-width: 768px) {
    .hh2-style1, .hh2-style2, .hh2-style3 {
        font-size: 20px;
        padding: 8px 16px;
    }
}
</style>
